var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAquaLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 44C0 24.927 0 15.39 5.175 8.908a23.684 23.684 0 013.733-3.733C15.39 0 24.927 0 44 0s28.61 0 35.092 5.175a23.685 23.685 0 013.734 3.733C88 15.39 88 24.927 88 44s0 28.61-5.174 35.092a23.686 23.686 0 01-3.734 3.734C72.61 88 63.073 88 44 88s-28.61 0-35.092-5.174a23.685 23.685 0 01-3.733-3.734C0 72.61 0 63.073 0 44z",
    fill: "#872AB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.07 40.46l9.811 9.774 9.743-9.711 4.276 4.236-14.017 13.973-9.813-9.776L36.597 64.37l-8.303-8.27-9.939 9.9-4.275-4.237 14.214-14.16 8.303 8.271L52.07 40.46z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.07 23.98l9.811 9.774 9.743-9.71 4.276 4.235-14.017 13.973-9.813-9.775L36.597 47.89l-8.303-8.271-9.939 9.9-4.275-4.237 14.214-14.16 8.303 8.271L52.07 23.981z",
    fill: "#fff"
  })));
}
export default SvgAquaLogoSmall;